/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementGenerateCertResponse } from './CarpsaleManagementGenerateCertResponse';

export type CarpsaleManagementGenerateCertResponseApiRespoonse = {
    data?: CarpsaleManagementGenerateCertResponse;
    status?: CarpsaleManagementGenerateCertResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementGenerateCertResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

